import React from "react";
import { formatCompactNumber } from "@/utils/formatCompactNumber";

const MetricTile = ({ value }) => {

  // First Created - 20 Dec 2025
  // Author - Atul Pandey
  // Purpose - Reusable square metric tile with compact value formatting

  return (
    <div className="aspect-square flex justify-center items-center w-12 h-12 bg-gradient-to-r from-black to-black via-gray-700 rounded">
      <p className="font-bold text-orange-600 text-sm leading-none">
        {formatCompactNumber(value)}
      </p>
    </div>
  );
};

export default MetricTile;
